import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "payment",
  COLLECTIONS: {
    ORDER: "order",
    WITHDRAW: "withdraw",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    order: collection(firestore, REF.COLLECTIONS.ORDER),
    withdraw: collection(firestore, REF.COLLECTIONS.WITHDRAW),
  };
  return CREF;
};
